/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_Calf_RightInputs */

const en_us2_body_measures_site_calf_right = /** @type {(inputs: Body_Measures_Site_Calf_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right calf`)
};

const pt_br2_body_measures_site_calf_right = /** @type {(inputs: Body_Measures_Site_Calf_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panturrilha dir.`)
};

const es_419_body_measures_site_calf_right = /** @type {(inputs: Body_Measures_Site_Calf_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantorrilla der.`)
};

const pt_pt2_body_measures_site_calf_right = /** @type {(inputs: Body_Measures_Site_Calf_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gémeo dir.`)
};

const fr_fr2_body_measures_site_calf_right = /** @type {(inputs: Body_Measures_Site_Calf_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mollet droit`)
};

const de_de2_body_measures_site_calf_right = /** @type {(inputs: Body_Measures_Site_Calf_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wade re.`)
};

const it_it2_body_measures_site_calf_right = /** @type {(inputs: Body_Measures_Site_Calf_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polpaccio dx`)
};

/**
* | output |
* | --- |
* | "Right calf" |
*
* @param {Body_Measures_Site_Calf_RightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_calf_right = /** @type {((inputs?: Body_Measures_Site_Calf_RightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_Calf_RightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_calf_right(inputs)
	if (locale === "es-419") return es_419_body_measures_site_calf_right(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_calf_right(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_calf_right(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_calf_right(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_calf_right(inputs)
	return en_us2_body_measures_site_calf_right(inputs)
});
export { body_measures_site_calf_right as "body-measures.site_calf_right" }